import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { getLanguage } from './util'

i18n
  .use(Backend)
  // 注入 react-i18next 实例
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    debug: true,
    lng: getLanguage(),
    detection: {
      order: ['navigator']
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json?v=20250619' // 保持动态路径
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      transKeepBasicHtmlNodesFor: ['div', 'label', 'span', 'strong', 'i', 'p'] // list of allowed tags
    }
  })

export default i18n
